import { useEffect } from 'react';

function useDebouncedEffect(
  effect: () => any,
  dependencies: React.DependencyList,
  delay: number
): void {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);
    return () => clearTimeout(handler);
  }, [...dependencies, delay]);
}

export default useDebouncedEffect;
